angular.module('filters').filter('withoutFraction', function() {
  return function(value = '') {
    return value.toString().split('.')[0];
  };
});
